import { randomIdentifier } from '@texas/utils/helpers/commonHelpers';
import { SearchQuery, EntityItem } from '../../../types';
import { materialsApi } from '@texas/api/endpoints/metadata/materialsApi';
import { ChatMessageEntityLinkType } from '@texas/api/endpoints/chat/chatApi';

export async function searchMaterial(
  query: SearchQuery,
): Promise<EntityItem[]> {
  const response = await materialsApi.search({
    searchTerm: query.query,
    sortBy: '',
    sortDesc: false,
    includeArchived: false,
  });

  if (response.hasError) {
    return [];
  }

  return response.data.map((c) => ({
    id: c.id,
    name: c.name,
    type: ChatMessageEntityLinkType.Material,
    identifier: randomIdentifier(),
  }));
}
